import * as firebase from "firebase";

export default {
  getUserData: function(userData) {
    firebase
      .database()
      .ref("/users/admin/")
      .once("value")
      .then((data) => {
        const adminData = data.val();
        if (userData.id in adminData) {
          userData.admin = true;
          userData.firstName = adminData[userData.id].firstName;
          userData.lastName = adminData[userData.id].lastName;
        } else {
          throw new Error("User database mismatch");
        }
      })
      .catch((error) => {
        throw new Error(error);
      });

    return userData;
  },
};
